import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetPurposeParams extends PaginationProps {}

interface CreatePurpose {
  abbreviation: string;
  fullName: string;
  phase: string;
  revisionIds: number[];
}

interface UpdatePurpose extends CreatePurpose {
  id: number | null;
}

export async function getPurposes() {
  const { data } = await api.get('/purposes');
  return data;
}

export async function getPurposesMasterData(params: GetPurposeParams) {
  const { data } = await api.get('/purposes/master-data', {
    params
  });
  return data;
}

export async function getPurpose(id: number) {
  const { data } = await api.get(`/purposes/${id}`);
  return data;
}

export async function createPurpose(createPurpose: CreatePurpose) {
  const { data } = await api.post('/purposes', createPurpose);
  return data;
}

export async function updatePurpose(updatePurpose: UpdatePurpose) {
  const { data } = await api.put(
    `/purposes/${updatePurpose.id}`,
    updatePurpose
  );
  return data;
}

export function deletePurpose(id: number) {
  return api.delete(`/purposes/${id}`);
}
